import { Component, ChangeDetectorRef } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import $ from "jquery";
import { HttpService } from "../../service/HTTPService/HttpService";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-AlarmHistoryactions-cell",
  template: `<select
      style="height: 29px;font-size: 13px;width: 96px; margin-top:3px;"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="
        optionChanged(
          $event.target.value,
          ackModal,
          clearModal,
          escalateModal,
          descriptionModal
        )
      "
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <option class="newOption" [disabled]="disableAck" value="Acknowledge">
        Acknowledge
      </option>
      <option class="newOption" [disabled]="disableClear" value="Clear">
        Clear
      </option>
      <option class="newOption" value="ViewTT" [disabled]="disableViewTT">
        View TT
      </option>
      <option class="newOption" value="Escalate">Notify</option>
      <option class="newOption" value="Description">Description</option>
      <hr />
    </select>
    <ng-template #ackModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Acknowledge</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="comment">Describe the alarm</label>
          <textarea
            class="form-control"
            rows="5"
            #comment
            id="ackcomment"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="ackClick"
          (click)="modal.dismiss('ack' + '_' + comment.value)"
        >
          Acknowledge
        </button>
      </div>
    </ng-template>
    <ng-template #clearModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Clear Alarm</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="clearcomment">Comment</label>
          <textarea
            class="form-control"
            rows="5"
            #clearcomment
            id="clearcomment"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="ackClick"
          (click)="modal.dismiss('clear' + '_' + clearcomment.value)"
        >
          Clear
        </button>
      </div>
    </ng-template>
    <ng-template #escalateModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Notify</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6" id="escalateHeaders">
                <p>Site ID | Name:</p>
                <p>Field Engineer ID:</p>
                <p id="enggId">Field Engineer:</p>
                <p id="enggPhn">Contact Number:</p>
                <p>Alarm:</p>
                <p>Generated On</p>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <p
                    title="{{ siteid_sitename }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ siteid_sitename }}
                  </p>
                  <p #enggId style="word-break: break-all;">
                    {{ fieldEnggId }}
                  </p>
                  <p
                    #enggName
                    title="{{ fieldEnggName }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ fieldEnggName }}
                  </p>
                  <p #enggPhn style="word-break: break-all;">
                    {{ fieldEnggContact }}
                  </p>
                  <p
                    title="{{ alarms }}"
                    style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >
                    {{ alarms }}
                  </p>
                  <p style="word-break: break-all;">{{ generatedOn }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" id="smsDiv">
                  <div id="chbk1">
                    <input
                      checked
                      type="checkbox"
                      class="form-check-input"
                      id="smsCheck"
                      (change)="onChange('smsCheck', $event.target.checked)"
                      style="margin-top: 10px;"
                    />
                    <label
                      style="padding-top: 7px;"
                      class="form-check-label"
                      for="smsCheck"
                      >SMS</label
                    >
                    <div style="float:right;width:85%;padding-bottom:10px">
                      <input
                        type="text"
                        pattern="d*"
                        maxlength="10"
                        class="form-control"
                        disabled="true"
                        id="enggContact"
                        #enggPhn
                      />
                    </div>
                  </div>
                  <textarea
                    #smstext
                    style="width:340px"
                    class="form-control"
                    rows="3"
                    id="smsTextArea"
                    disabled="true"
                    >{{ smsText }}</textarea
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" id="emailDiv">
                  <div id="chbk2">
                    <input
                      checked
                      type="checkbox"
                      class="form-check-input"
                      id="emailCheck"
                      (change)="onChange('emailCheck', $event.target.checked)"
                      style="margin-top: 10px;"
                    />
                    <label
                      style="padding-top: 7px;"
                      class="form-check-label"
                      for="emailCheck"
                      >Email</label
                    >
                    <div style="float:right;width:85%;padding-bottom:10px">
                      <input
                        type="email"
                        class="form-control"
                        id="emailId"
                        placeholder="Enter email"
                        #enggMail
                        disabled="true"
                      />
                    </div>
                  </div>
                  <textarea
                    #emailtext
                    style="width:340px"
                    class="form-control"
                    rows="5"
                    id="mailTextArea"
                    disabled="true"
                    >{{ mailText }}</textarea
                  >
                  <label style="padding-top:10px">Additional Comments</label>
                  <textarea
                    #comentTextArea
                    style="width:340px"
                    class="form-control"
                    rows="2"
                    id="comentTextArea"
                    disabled="true"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          value="cancelClick"
          (click)="modal.dismiss('cancel')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          value="sendClick"
          (click)="
            escalate(
              'escalate',
              enggPhn.value,
              enggMail.value,
              smstext.value,
              emailtext.value,
              comentTextArea.value
            )
          "
        >
          Send
        </button>
      </div>
    </ng-template>
    <ng-template #descriptionModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Alarm Description</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4" style="text-align:right;">
            <p>Site ID | Name:</p>
            <p>Alarm:</p>
            <p>Generated On:</p>
            <p>Description:</p>
          </div>
          <div class="col-md-8">
            <p style="word-break: break-all;">{{ siteid_sitename }}</p>
            <p style="word-break: break-all;">{{ alarms }}</p>
            <p style="word-break: break-all;">{{ generatedOn }}</p>
            <p style="word-break: break-all;">{{ description }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          value="closeClick"
          (click)="modal.dismiss('close')"
        >
          Close
        </button>
      </div>
    </ng-template> `,
  styles: [
    `
      .modal-footer button {
        width: 150px !important;
      }
    `,
  ],
})
export class AlarmHistoryActionRendererComponent
  implements ICellRendererAngularComp
{
  selectedoption = "Action";
  closeResult: string;
  public params: any;
  public sid = "";
  alarmId = "";
  sitecode = "";
  sitename = "";
  timeelapsed = "";
  description = "";
  siteid_sitename = "";
  generatedOn = "";
  alarms = "";
  cluster = "";
  fieldEnggName = "NA";
  fieldEnggContact = "NA";
  CustomerID;
  fieldEnggId = "NA";
  smsText = "";
  smsChecks = false;
  mailChecks = false;
  mailText = "";
  ack_dt = "";
  clear_dt = "";
  disableAck = false;
  disableClear = false;
  disableViewTT = true;
  IsAcknowledged: any;
  ttNumber = "";

  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private cdr: ChangeDetectorRef,
    private http: HttpService,
    private globals: Globals,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";
    const token = sessionStorage.getItem("invUIToken");

      let replacedArray: any = [];
      let Base64 = {
        _keyStr:
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        encode: function (e) {
          let t = "";
          let n, r, i, s, o, u, a;
          let f = 0;
          e = Base64._utf8_encode(e);
          while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = ((n & 3) << 4) | (r >> 4);
            u = ((r & 15) << 2) | (i >> 6);
            a = i & 63;
            if (isNaN(r)) {
              u = a = 64;
            } else if (isNaN(i)) {
              a = 64;
            }
            t =
              t +
              this._keyStr.charAt(s) +
              this._keyStr.charAt(o) +
              this._keyStr.charAt(u) +
              this._keyStr.charAt(a);
          }
          return t;
        },
        decode: function (e) {
          let t = "";
          let n, r, i;
          let s, o, u, a;
          let f = 0;
          e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
          while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = (s << 2) | (o >> 4);
            r = ((o & 15) << 4) | (u >> 2);
            i = ((u & 3) << 6) | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
              t = t + String.fromCharCode(r);
            }
            if (a != 64) {
              t = t + String.fromCharCode(i);
            }
          }
          t = Base64._utf8_decode(t);
          return t;
        },
        _utf8_encode: function (e) {
          e = e.replace(/\r\n/g, "\n");
          let t = "";
          for (let n = 0; n < e.length; n++) {
            let r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
              t += String.fromCharCode((r >> 6) | 192);
              t += String.fromCharCode((r & 63) | 128);
            } else {
              t += String.fromCharCode((r >> 12) | 224);
              t += String.fromCharCode(((r >> 6) & 63) | 128);
              t += String.fromCharCode((r & 63) | 128);
            }
          }
          return t;
        },
        _utf8_decode: function (e) {
          let t = "";
          let n = 0;
          let r = 0;
          let c2 = 0;
          while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
              n++;
            } else if (r > 191 && r < 224) {
              c2 = e.charCodeAt(n + 1);
              t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
              n += 2;
            } else {
              c2 = e.charCodeAt(n + 1);
              let c3 = e.charCodeAt(n + 2);
              t += String.fromCharCode(
                ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
              );
              n += 3;
            }
          }
          return t;
        },
      };
      let string = token;
      let decodedString = Base64.decode(string);
      replacedArray = decodedString.replace(/}{/, "},{");

      replacedArray = decodedString.substring(0, decodedString.length - 138);
      let createingJson = [{ response: replacedArray }];
      this.CustomerID = createingJson[0].response;
  }
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
    this.alarmId = this.params.data.alarmid;
    this.description = this.params.data.description;

    this.generatedOn = this.params.data.generatedOn;
    this.alarms = this.params.data.alarms;
    this.fieldEnggName = this.params.data.fieldEngg;
    this.fieldEnggContact = this.params.data.contact;
    this.timeelapsed = this.params.data.timeElapsed;
    this.sitecode = this.params.data.siteCode;
    this.sitename = this.params.data.sitename;
    this.siteid_sitename = this.sitecode + " | " + this.sitename;
    this.cluster = this.params.data.cluster;
    this.fieldEnggId = this.params.data.fieldEnggID;
    this.ack_dt = this.params.data.Ack_dt;
    this.clear_dt = this.params.data.clear_dt;
    this.IsAcknowledged = this.params.data.IsAcknowledged;
    this.ttNumber = this.params.data.ttNumber;
    if (this.IsAcknowledged > 0) {
      this.disableAck = true;
    }
    if (this.clear_dt != "") {
      this.disableClear = true;
    }
    if (!this.fieldEnggId) {
      this.fieldEnggId = "NA";
    }
    if (!this.fieldEnggContact) {
      this.fieldEnggContact = "NA";
    }
    if (!this.fieldEnggName) {
      this.fieldEnggName = "NA";
    }
    if (this.CustomerID.includes('"acCustomerId":20') == true) {
      this.disableViewTT = true;
    } else {
      if (
        this.ttNumber != "0" &&
        this.ttNumber != null &&
        this.ttNumber != ""
      ) {
        this.disableViewTT = false;
      }
    }
  }
  refresh(): boolean {
    return false;
  }
  optionChanged(option, ackModal, clearModal, escalateModal, descriptionModal) {
    this.selectedoption = "";
    this.cdr.detectChanges();

    if (option == "Acknowledge" && ackModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(ackModal);
    } else if (option == "Clear" && clearModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(clearModal);
    } else if (option == "ViewTT") {
      this.selectedoption = "Action";
      const str = '{"Reference":"' + this.ttNumber + '"}';
      const encr = window.btoa(str);
      let link = "#/troubleTicket";
      window.open(link + "?e=" + encr, "_self");
    } else if (option == "Escalate" && escalateModal != undefined) {
      this.selectedoption = "Action";
      this.smsText =
        "Alarm : " +
        this.alarms +
        "\n" +
        "Site :" +
        this.siteid_sitename +
        "\n" +
        "Cluster :" +
        this.cluster;
      this.mailText =
        'Hi ,\n\n"' +
        this.alarms +
        '" happened for site "' +
        this.siteid_sitename +
        '" on ' +
        this.generatedOn +
        "\n\n" +
        "Thanks,\n iTOC Admin";
      this.openLg(escalateModal);
      this.onChange("smsCheck", true);
      this.onChange("mailCheck", true);
    } else if (option == "Description" && descriptionModal != undefined) {
      this.selectedoption = "Action";
      this.openModal(descriptionModal);
    } else if (option == "dtldashbrd") {
      this.selectedoption = "Action";
      const link = "#/siteDetails";
      const str = '{"siteID":"' + this.sid + '"}';
      const encr = window.btoa(str);
      window.open(link + "?e=" + encr, "_self");
    } else if (option == "alrmHistory") {
      this.selectedoption = "Action";
      const link = "#/alarmHistory";
      window.open(
        link +
          "?siteID=" +
          this.sid +
          "&sitename=" +
          this.sitename +
          "&siteCode=" +
          this.sitecode,
        "_self"
      );
    }
  }
  onChange(name: string, isChecked: boolean) {
    if (isChecked && name.includes("smsCheck")) {
      this.smsChecks = true;
      $("#smsTextArea").prop("disabled", false);
      $("#enggContact").prop("disabled", false);

      $("#smsTextArea").val(this.smsText);
    } else if (!isChecked && name.includes("smsCheck")) {
      this.smsChecks = false;
      $("#smsTextArea").prop("disabled", true);
      $("#enggContact").prop("disabled", true);
      $("#enggContact").val("");
      $("#smsTextArea").val("");
    } else if (isChecked && name.includes("mailCheck")) {
      this.mailChecks = true;
      $("#mailTextArea").prop("disabled", false);
      $("#emailId").prop("disabled", false);
      $("#comentTextArea").prop("disabled", false);
      $("#mailTextArea").val(this.mailText);
    } else if (!isChecked && name.includes("mailCheck")) {
      this.mailChecks = false;
      $("#mailTextArea").prop("disabled", true);
      $("#emailId").prop("disabled", true);
      $("#comentTextArea").prop("disabled", true);
      $("#mailTextArea").val("");
      $("#emailId").val("");
      $("#comentTextArea").val("");
    }
  }
  /**
   * To open the Export Modal
   * @param content
   */
  openModal(content) {
    this.mailChecks = false;
    this.smsChecks = false;
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  openLg(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else if (reason.includes("ack")) {
      const comment = reason.substring(4, reason.length);
      this.acknowledge(comment);
    } else if (reason.includes("clear")) {
      const comment = reason.substring(6, reason.length);
      this.clearAction(comment);
    } else {
      return `with: ${reason}`;
    }
  }

  escalate(option, enggPhn, enggMail, smstext, emailtext, commentText) {
    this.modalService.dismissAll("escalate");
    if (this.smsChecks) {
      if (enggPhn != "" && smstext != "") {
        var matches = enggPhn.match(/[0-9]/g);
        if (enggPhn.length === 10 && matches != "" && matches != undefined) {
          const smsJson = {
            AlarmID: this.alarmId,
            SiteID: this.sid,
            EngineerName: this.fieldEnggName,
            EnginerNumber: enggPhn,
            SMSText: smstext,
          };
          this.http
            .post(
              this.urlAuthentication.itocUrl + this.apiUrl.actionEscalateSMSUrl,
              smsJson
            )
            .subscribe(
              (res) => {
                const getResp: string = JSON.stringify(res.body);
                if (getResp.includes("SMS sending intiated.")) {
                  this.setMessage(
                    "Successfully SMS/Email sending intiated",
                    "success"
                  );
                } else {
                  this.setMessage(
                    "Could not send SMS, Please try again",
                    "danger"
                  );
                }
              },
              (error) => {
                console.error(error);

                this.setMessage(
                  "Could not send SMS, Please try again",
                  "danger"
                );
              }
            );
        } else {
          this.setMessage("Please enter a valid contact number", "danger");
        }
      } else {
        this.setMessage(
          "Please fill all mandatory details to send SMS",
          "danger"
        );
      }
    }
    if (this.mailChecks) {
      if (enggMail != "" && emailtext != "") {
        var mailMatch = enggMail.match(
          /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
        );
        if (mailMatch != "" && mailMatch != undefined) {
          const mailJson = {
            AlarmID: this.alarmId,
            SiteID: this.sid,
            SiteCode: this.sitecode,
            SiteName: this.sitename,
            EngineerName: this.fieldEnggName,
            EngineerMail: enggMail,
            MailText: emailtext,
            AlarmName: this.alarms,
            OpenTime: this.generatedOn,
            TimeElapsed: this.timeelapsed,
            Comments: commentText,
          };
          this.http
            .post(
              this.urlAuthentication.itocUrl +
                this.apiUrl.actionEscalateMailUrl,
              mailJson
            )
            .subscribe(
              (res) => {
                const getResp: string = JSON.stringify(res.body);
                if (getResp.includes("Email sending intiated.")) {
                  this.setMessage(
                    "Successfully SMS/Email sending intiated",
                    "success"
                  );
                } else {
                  this.setMessage(
                    "Could not send Email, Please try again",
                    "danger"
                  );
                }
              },
              (error) => {
                console.error(error);

                this.setMessage(
                  "Could not send Email, Please try again",
                  "danger"
                );
              }
            );
        } else {
          this.setMessage("Please enter a valid Email ID", "danger");
        }
      } else {
        this.setMessage(
          "Please fill all mandatory details to send Email",
          "danger"
        );
      }
    }
    if (!this.smsChecks && !this.mailChecks) {
      this.setMessage(
        "Please select the checkboxes to send SMS/Email",
        "danger"
      );
    }
  }
  acknowledge(comment) {
    if (comment != "") {
      const jsonData = {
        AlarmID: this.alarmId,
        Description: comment,
      };
      this.http
        .post(
          this.urlAuthentication.itocUrl + this.apiUrl.actionAckUrl,
          jsonData
        )
        .subscribe(
          (res) => {
            const getImgResp: string = JSON.stringify(res.body);
            if (getImgResp.includes("Alarm Acknowledged.")) {
              this.setMessage(
                "Acknowledged and Description updated",
                "success"
              );
            } else {
              this.setMessage(
                "Acknowledgement failed !!!, Please try again",
                "danger"
              );
            }
          },
          (error) => {
            console.error(error);

            this.setMessage(
              "Acknowledgement failed !!!, Please try again",
              "danger"
            );
          }
        );
    } else {
      this.setMessage(
        "Alarm Description should not be empty, Please try again",
        "danger"
      );
    }
  }
  clearAction(comment) {
    const jsonData = { AlarmID: this.alarmId, Description: comment };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.actionClearUrl,
        jsonData
      )
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res.body);
          if (getImgResp.includes("Alarm Cleared.")) {
            this.setMessage("Alarm Cleared Successfully", "success");
          } else {
            this.setMessage("Alarm not cleared!!!, Please try again", "danger");
          }
        },
        (error) => {
          console.error(error);

          this.setMessage("Alarm not cleared!!!, Please try again", "danger");
        }
      );
  }
  setMessage(msg, type) {
    this.globals.message = "";
    this.globals.messageType = "";
    this.globals.message = msg;
    this.globals.messageType = type;
    this.params.context.componentParent.ngBeforeViewInit();
  }
}
